import getJsUTC from "./getJsUTC";
import { getAuth } from "firebase/auth";
import { Timestamp } from "firebase/firestore";

const HelperForMetaData = (obj = {}, loop = false, isDeleted = false) => {
  obj = {
    ...obj,
    modifiedAt: Timestamp.fromDate(new Date(getJsUTC())),
    modifiedBy: getAuth().currentUser.uid,
    is_deleted: isDeleted,
  };

  if (loop === false) {
    if (!obj.hasOwnProperty("createdAt"))
      obj = {
        ...obj,
        createdAt: Timestamp.fromDate(new Date(getJsUTC())),
        createdBy: getAuth().currentUser.uid,
      };
  }

  return obj;
};

export default HelperForMetaData;
